import { InMemoryCache } from 'apollo-cache-inmemory';

export class BroadcastConfigurableInMemoryCache extends InMemoryCache {
	private shouldBroadcast: boolean = true;

	constructor(...args: ConstructorParameters<typeof InMemoryCache>) {
		super(...args);

		// On server-side components have no chance to re-render thus broadcasting change is useless
		// On client-side we don't want to broadcast until the hydration is done.
		if (
			// Allow broadcast in tests
			!process.env.JEST_WORKER_ID &&
			// @ts-ignore TODO FIXME
			!window.Cypress &&
			// @ts-ignore Property 'isPlaywright' does not exist on type 'Window & typeof globalThis'
			!window.isPlaywright &&
			// @ts-expect-error Property isContract doesn't exist on window
			!window.isContract
		) {
			this.shouldBroadcast = false;
		}
	}

	protected override broadcastWatches(): void {
		if (this.shouldBroadcast) {
			super.broadcastWatches();
		}
	}

	public stopBroadcast() {
		this.shouldBroadcast = false;
	}

	public startBroadcast() {
		if (!this.shouldBroadcast) {
			this.shouldBroadcast = true;
			this.broadcastWatches();
		}
	}
}
